export default __webpack_public_path__ + "static/media/stewardship_asia_logo.102337e0.svg";